import reducers from './reducers'

export { default as trainingsTypes } from './types'
export { default as trainingsActions } from './actions'
export { default as trainingsSelectors } from './selectors'
export { default as trainingsEpics } from './epics'

export default reducers
